import styles from '../styles/GroupTwo.module.css'
import { GrLogin } from 'react-icons/gr'
import { AiOutlineUserAdd } from 'react-icons/ai'
import { Link } from 'react-router-dom'

export default function UnlogedSection() {
  return (
    <>
      <div className={styles.questionunloged}>
        <button>Criar pergunta</button>
      </div>
      <div className={styles.login}>
        <Link to='/login'>
          <span>Entrar</span>
          <GrLogin />
        </Link>
      </div>
      <div className={styles.singup}>
        <Link to='/singup'>
          <span>Criar conta</span>
          <AiOutlineUserAdd />
        </Link>
      </div>
    </>
  )
}